import React, { Component } from 'react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import {
  inject,
  observer,
} from 'mobx-react';

class SlumpMeter extends Component {
  render() {
    const { device, batchStore } = this.props;
    const slumpData = batchStore.getActualSlumpData(device.id);

    return (
      <div id={`device-${device.id}`} className={`device-gui device-gui--analog-input analog-input${slumpData}`}>
        <div className="device-label device-icon">
          <div className="device-type" title={`#${device.id}`}>{device.description || `Slump Meter #${device.id}`}</div>
          <div className="balance">{slumpData}</div>
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(inject('batchStore')(observer(SlumpMeter)));
